import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, Validators } from '@angular/forms';

import * as fromModel from '../../services/models/';
import { DataService } from '../../services/context/data.service';
import { Subscription } from 'rxjs';
import { UIStateService } from '../../services/context//uistate.service';
import { PlanService } from '../../services/plan.service';


@Component({
  selector: 'gp-save-plan',
  templateUrl: './save-plan.component.html',
  styleUrls: ['./save-plan.component.scss']
})
export class SavePlanComponent implements OnInit, OnDestroy {

  errorMsg: string;
  isDataAvailable: boolean = false;  
  defaultPlanName: string;
  
  protected _storeDataSubscription: Subscription;  

  planName = new FormControl('', [Validators.maxLength(40), Validators.required]);
  planId;

  constructor(private dataService: DataService, 
    private planService: PlanService,
    private uiStateService: UIStateService,
    private dialogRef: MatDialogRef<SavePlanComponent>,
    @Inject(MAT_DIALOG_DATA) private inputData: any) { 
      // this.defaultPlanName = inputData.defaultPlanName;
      // if(this.defaultPlanName.length>40){
      //   this.defaultPlanName = this.defaultPlanName.substr(0,37) + "...";
      // }
      
    }

    ngOnInit(): void {
      this.planName.setValue(this.defaultPlanName);
      this._storeDataSubscription = this.dataService.subscribe((documentContext: fromModel.IAppData) => this.populateAppData(documentContext));
    }

    private populateAppData(appData: fromModel.IAppData){
    if(appData && appData.action !== fromModel.DATA_ACTION.NONE) {      
      if(appData.Plan && appData.Plan.planName) {
        this.planName.setValue(appData.Plan.planName);
        this.planId = appData.Plan.id;
      } 
    }
  }
  

  ngOnDestroy(): void{
    if(this._storeDataSubscription && this._storeDataSubscription !== null){
      this._storeDataSubscription.unsubscribe();
    }
  }

  closeDialog(): void {
    this.dialogRef.close();    
  } 

  private showErrorMsg(msg){
    this.errorMsg = msg;
  }

  savePlan(){
    let result;
    if(!this.planName.invalid){
      this.dataService.dispatchAction(fromModel.DATA_ACTION.PLANIDNAME, "SavePlanComponent-savePlan", {id: this.planId, planName: this.planName.value});
      result = this.dataService.savePlan();
      if(result===null){ 
        this.isDataAvailable = false;
        this.showErrorMsg("Save failed!")
      } else {
        //this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWPROGRESSBAR, "SavePlanComponent-savePlan", true);
        this.isDataAvailable = true;
        this.closeDialog();        
      }      
    }
  }


}
